import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PopupBlockerService {
  checkIfPopupBlocked(): boolean {
    const popup = window.open('', '_self');
    if (popup) {
      popup.close();  // Close the pop-up if it's allowed
      return false;   // Pop-up is not blocked
    }
    return true;      // Pop-up is blocked
  }
}
